// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoAction_root__O_Lsx","info":"InfoAction_info__1kyHH"};